module.exports = __webpack_public_path__ + "static/bezvezze-8fbfb95f1fc6df767244f8ed86fcfa66.jpg";